export default __webpack_public_path__ + "static/media/logo-menu.086cfad1.svg";